import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface ArticleCardProps {
  article: Article;
  size?: "small" | "medium" | "large";
}

export default function ArticleCard({ article, size = "medium" }: ArticleCardProps) {
  const isLarge = size === "large";
  const isSmall = size === "small";

  return (
    <Link
      to={`/article/${article.id}`}
      className={`group block bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 overflow-hidden ${
        isLarge ? "lg:grid lg:grid-cols-2" : ""
      }`}
    >
      <div className={`relative overflow-hidden ${isLarge ? "aspect-[4/3] lg:aspect-auto" : isSmall ? "aspect-[4/3]" : "aspect-[16/9]"}`}>
        <img
          src={article.image}
          alt={article.title}
          title={`${article.title} - 探花精选推荐`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="inline-block px-2.5 py-1 text-xs font-medium rounded-full bg-background-50/90 text-foreground-700 backdrop-blur-sm">
            {article.category === "jingxuan-tuijian" && "精选推荐"}
            {article.category === "shendu-pingce" && "深度评测"}
            {article.category === "dujia-faxian" && "独家发现"}
            {article.category === "pinzhi-shenghuo" && "品质生活"}
            {article.category === "keji-shuma" && "科技数码"}
            {article.category === "wenhua-yuedu" && "文化阅读"}
          </span>
        </div>
      </div>
      <div className={`p-4 md:p-5 ${isLarge ? "flex flex-col justify-center" : ""}`}>
        <h3
          className={`font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 ${
            isLarge ? "text-xl md:text-2xl" : isSmall ? "text-sm" : "text-base md:text-lg"
          }`}
        >
          {article.title}
        </h3>
        {!isSmall && (
          <p className="mt-2 text-sm text-foreground-500 line-clamp-2 leading-relaxed">
            {article.excerpt}
          </p>
        )}
        <div className={`mt-3 flex items-center gap-3 text-xs text-foreground-400 ${isSmall ? "mt-2" : ""}`}>
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {article.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime}分钟阅读
          </span>
        </div>
      </div>
    </Link>
  );
}